import { combineReducers } from "redux";
import commonReducer from "./commonReducer";
import userReducer from "./userReducer";
import applicationReducer from "./applicationReducer"
import loginReducer from "./LoginReducer";
import SideBarReducer from "../redux/SideBar/sideBarReducer"
import settingsReducer from "./settingsReducer";
import createAccountReducer from "./createAccountReducer";

const rootReducer = combineReducers({
    commonReducer,
    userReducer,
    applicationReducer,
    loginReducer,
    SideBarReducer,
    settingsReducer,
    createAccountReducer
});

export default rootReducer;
